/**
 * Placeholder pricing hook for the Ultrahuman × Les Mills bundle.
 * Mirrors the shape of useCluePricing so swapping to real Shopify-backed
 * pricing later is a single-file change.
 */
export const useLesMillsPricing = () => {
  const ringPriceDisplay = '$349';
  const lesMillsPriceDisplay = '$14.95/mo';
  const lesMillsDiscountedDisplay = '$0';
  const bundlePriceDisplay = '$349';

  return {
    ringPriceDisplay,
    lesMillsPriceDisplay,
    lesMillsDiscountedDisplay,
    bundlePriceDisplay,
  } as const;
};

export default useLesMillsPricing;
